import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { colors, fontSizes, media } from '../styles';

const propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  size: PropTypes.string,
  mobileSize: PropTypes.string,
  color: PropTypes.string,
  fontWeight: PropTypes.number,
  italic: PropTypes.bool
};

const Text = props => {
  const { children, className, color = 'midnightBlack', fontWeight = 400, italic, size = 'medium', mobileSize } = props;

  return (
    <StyledText
      className={className}
      size={size}
      mobileSize={mobileSize}
      color={color}
      fontWeight={fontWeight}
      italic={italic}
    >
      {children}
    </StyledText>
  );
};

Text.propTypes = propTypes;

const StyledText = styled.p`
  color: ${({ color }) => colors[color]};
  font-family: Lato, sans-serif;
  font-style: ${({ italic }) => (italic ? 'italic' : 'normal')};
  font-weight: ${({ fontWeight }) => fontWeight};
  font-size: ${({ size }) => fontSizes.paragraph[size].fontSize};
  line-height: ${({ size }) => fontSizes.paragraph[size].lineHeight};
  margin: 0;

  @media screen and (max-width: ${media.mediumBottom}) {
    font-size: ${({ size, mobileSize }) =>
      mobileSize ? fontSizes.paragraph[mobileSize].mobile.fontSize : fontSizes.paragraph[size].mobile.fontSize};
    line-height: ${({ size, mobileSize }) =>
      mobileSize ? fontSizes.paragraph[mobileSize].mobile.lineHeight : fontSizes.paragraph[size].mobile.lineHeight};
  }
`;

export { Text };
